<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>
              <router-link
                class="btn btn-sm"
                :to="{ name: 'RoutingStaticList' }"
                ><i class="fas fa-chevron-left"></i>
              </router-link>
              Static Routing
            </h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Static Routing</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="RoutingStatic">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
            </div>
            <div class="card-body pb-1">
              <div class="row">
                <div class="col-md-8">
                  <div v-if="organizationId == 1 || is_copy" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="accountId"
                      class="form-control accountId"
                      name="accountId"
                      readonly
                    />

                    <multiselect
                      v-else
                      v-model="value.accountId"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="opt => pre.audraName[opt]"
                      placeholder="Select Audra Name"
                      :searchable="true"
                      :multiple="false"
                      id="accountId"
                      v-bind:class="{ 'has-error': errors.has('accountId') }"
                      v-validate="'required'"
                      name="accountId"
                    >
                    </multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('accountId')"
                    >
                      {{ errors.first('accountId') }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="routing_name"
                      name="Name"
                      v-model="value.routing_name"
                      v-validate.lazy="'required'"
                      class="form-control routing_name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('Name')">
                      {{ errors.first('Name') }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Network Address</label>
                    <input
                      type="text"
                      id="network_address"
                      name="Network Address"
                      v-model="value.network_address"
                      v-validate.lazy="'required|ip_CIDR'"
                      class="form-control network_address"
                      placeholder="Network Address"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('Network Address')"
                    >
                      {{ errors.first('Network Address') }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Gateway</label>
                    <input
                      type="text"
                      id="gateway"
                      name="gateway"
                      v-model="value.gateway"
                      v-validate="'required|ip'"
                      class="form-control gateway"
                      placeholder="Gateway"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('gateway')"
                    >
                      {{ errors.first('gateway') }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Metric</label>

                    <input
                      type="text"
                      id="metric"
                      name="metric"
                      v-validate="'MATRIC'"
                      v-bind:class="{ 'has-error': errors.has('metric') }"
                      v-model="value.metric"
                      class="form-control metric"
                      placeholder="metric"
                    />
                    <div class="help text-danger" v-show="errors.has('metric')">
                      {{ errors.first('metric') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer pt-0 pb-4">
              <button type="submit" v-if="!is_edit" class="btn">Submit</button>
              <button type="submit" v-if="is_edit" class="btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { CommonAPI } from '@/services/api'
import LocalStorage from '@/services/localStorage'
import axios from 'axios'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'RoutingStaticForm',
  metaInfo: {
    title: 'Static Routing | Dotlines'
  },
  components: {
    DatePicker
  },
  data: () => ({
    organizationId: LocalStorage.get('organizationId'),
    userEmail: LocalStorage.get('userEmail'),
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    is_copy: false,
    params: {},

    value: {},
    pre: {
      audraName: []
    }
  }),
  methods: {
    handleSubmission () {
      const _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.is_loading = true
          let api_url = '/routing_static'
          let method = 'POST'
          if (_this.is_edit) {
            api_url = '/routing_static/' + _this.$route.params.id
            method = 'PUT'
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { 'Content-Type': 'application/json' }
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message)
              _this.$router.push({ name: 'RoutingStaticList' })
            })
            .catch(errors => {
              if (errors.response.status === 501) {
                _this.$toaster.error(errors.response.data.errors.message)
                _this.$setErrorsFromResponse(errors.response.data.errors)
              } else if (errors.response.data) {
                _this.$toaster.error(errors.response.data.message)
                _this.$setErrorsFromResponse(errors.response.data)
              }
            })
            .finally(() => {
              _this.is_loading = false
            })
        }
      })
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        const api_url = '/routing_static/' + id
        axios
          .get(api_url, {
            params: { accountId: LocalStorage.get('accountId') }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            // console.log("error " + error);
            reject(error)
          })
      })
    },
    async initialize () {
      this.is_loading = true
      this.params = this.$route.params
      if (
        !_.isEmpty(this.params) &&
        this.params.id !== undefined &&
        this.params.isCopy !== undefined
      ) {
        this.is_copy = true;
      } else if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit || this.is_copy) {
        await this.getDetail(this.params.id)
          .then(response => {
            this.value = response.data
          })
          .catch(errors => {
            if (errors.response.status === 501) {
              this.$toaster.error(errors.response.data.errors.message);
              this.$setErrorsFromResponse(errors.response.data.errors);
            } else if (errors.response.data) {
              this.$toaster.error(errors.response.data.message);
              this.$setErrorsFromResponse(errors.response.data);
            }
            this.$router.back()
          })
      } else {
        this.value.accountId = LocalStorage.get('accountId')
      }

      await CommonAPI.getAudraName(LocalStorage.get('accountId')).then(
        response => {
          this.pre.audraName = response
        }
      )

      this.is_loading = false
      this.setCustomValidation()
      this.setCustomValidationName()
      this.setCustomValidationIP()
      this.setCustomValidationMatric()
    },

    setCustomValidation: function () {
      this.$validator.extend('ip_CIDR', {
        getMessage: field =>
          'The input format is invalid. Valid Format : 192.168.20.0/24',
        validate: value => {
          return this.validateIpCidr(value) ? 1 : 0
        }
      })
    },
    setCustomValidationIP: function () {
      this.$validator.extend('IP', {
        getMessage: field =>
          'The input format is invalid. Valid Format : 192.168.100.1',
        validate: value => {
          return this.validateIp(value) ? 1 : 0
        }
      })
    },

    setCustomValidationName: function () {
      this.$validator.extend('NAME', {
        getMessage: field =>
          'The input format is invalid. Valid Format : 192.168.100.1',
        validate: value => {
          return this.alphaNum(value) ? 1 : 0
        }
      })
    },
    setCustomValidationMatric: function () {
      this.$validator.extend('MATRIC', {
        getMessage: field => 'The input format is invalid. Valid Format : 1000',
        validate: value => {
          return this.isNumber(value) ? 1 : 0
        }
      })
    },
    validateIpCidr (value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(3[0-2]|[0-2]?[0-9])$/
      return ipAddressPattern.test(value) ? 1 : 0
    },

    validateIp (value) {
      const ipAddressPattern = /^(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[0-1]?[0-9][0-9]?)$/
      return ipAddressPattern.test(value) ? 1 : 0
    },

    alphaNum (value) {
      const alphaNum = /^[a-zA-Z0-9_]*$/
      return alphaNum.test(value) ? 1 : 0
    },
    isNumber (value) {
      const digitRezex = /^\d{1,8}$/
      return digitRezex.test(value) ? 1 : 0
    }
  },
  mounted () {
    this.initialize()
  }
}
</script>
